import React, { useContext } from "react";
import { FieldRenderProps } from "react-final-form";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import { i18nContext } from "../../model/I18n";

export interface ListInputProps extends FieldRenderProps<any> {
  readOnly: boolean;
  values?: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: 4,
      minWidth: 150,
      position: "relative"
    }
  })
);

export const ListInput = (props: ListInputProps) => {
  const classes = useStyles();
  const { input, readOnly } = props;
  const i18n = useContext(i18nContext);
  const placeholder = i18n.t(
    "lego:field.listInput.placeholder",
    "Type and press Enter to add"
  );

  const error = props.meta.error;

  const handleChange = (opt: any, values: any[]) => {
    if (values && values.length > 0) {
      props.input.onChange(values);
    } else {
      props.input.onChange(null);
    }
  };

  return (
    <Autocomplete
      className={classes.root}
      multiple
      options={[]}
      disabled={readOnly}
      value={input.value}
      freeSolo
      size="small"
      onChange={handleChange}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={option + index}
            label={option}
            deleteIcon={readOnly ? <></> : undefined}
            size="small"
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          helperText={error && error.props.error.message}
          error={error !== undefined}
          variant="outlined"
          placeholder={readOnly ? undefined : placeholder}
          fullWidth
        />
      )}
    />
  );
};
